import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AnalysisHistory from '../components/AnalysisHistory';

const HistoryPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleViewAnalysis = (analysisId) => {
    navigate(`/analysis/${analysisId}`);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Page Header */}
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            {t('history.title')}
          </h1>
          <p className="text-gray-600">
            {t('history.subtitle')}
          </p>
        </div>

        <AnalysisHistory onViewAnalysis={handleViewAnalysis} />
      </div>
    </div>
  );
};

export default HistoryPage;
